import script from "./refunds.vue?vue&type=script&setup=true&lang=js"
export * from "./refunds.vue?vue&type=script&setup=true&lang=js"

import "./refunds.vue?vue&type=style&index=0&id=77df1c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77df1c5e"]])

export default __exports__